"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateClients = updateClients;
const rpc = __importStar(require("vscode-jsonrpc/node"));
const connect_1 = __importDefault(require("../connect"));
/**
 * Updates the clients by connecting to Kiota and sending a request to update.
 *
 * @param {UpdateClientsConfiguration} config - The configuration object containing the following properties:
 * @param {boolean} config.cleanOutput - Whether to clean the output directory before updating.
 * @param {boolean} config.clearCache - Whether to clear the cache before updating.
 * @param {string} config.workspacePath - The path to the workspace where the clients are located.
 *
 * @returns {Promise<KiotaLogEntry[] | undefined>} A promise that resolves to an array of Kiota log entries if the update is successful, or undefined if there is an error.
 *
 * @throws {Error} Throws an error if the result of the update is an instance of Error.
 */
async function updateClients({ cleanOutput, clearCache, workspacePath }) {
    const result = await (0, connect_1.default)(async (connection) => {
        const request = new rpc.RequestType3("Update");
        return await connection.sendRequest(request, workspacePath, cleanOutput, clearCache);
    });
    if (result instanceof Error) {
        throw result;
    }
    return result;
}
;
//# sourceMappingURL=updateClients.js.map